<template>
	<v-snackbar
		v-if="count"
		:key="current.dir"
		v-model="value"
		:color="current.color || defaults.color"
		:timeout="current.timeout || defaults.timeout"
		:dir="current.dir || defaults.dir"
		top
		right
		@click.native="goToRoute"
	>
		<v-card flat tile class="transparent">
			<v-card-title class="pl-0">
				<span class="text-subtitle-1">{{ current.title }}</span>
				<v-spacer></v-spacer>
				<v-btn icon @click.capture="value = false">
					<v-icon>mdi-window-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text v-if="current.body && current.body != 'null'">
				<span class="text-subtitle-2">{{ current.body }}</span>
			</v-card-text>
		</v-card>
	</v-snackbar>
</template>

<script>
export default {
	props: {
		notifier: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			defaults: {
				timeout: 12000, // 12 seconds
				color: "primary",
				dir: this.$vuetify.rtl ? "rtl" : "ltr"
			},

			value: false,
			notificationStack: []
		};
	},
	computed: {
		count() {
			return this.notificationStack.length;
		},
		current() {
			return this.notificationStack[0];
		}
	},
	watch: {
		notifier(newNotification) {
			console.log(newNotification)
			this.notificationStack.push(newNotification);
			this.value = true;
		},
		value(newValue) {
			if (newValue == false && this.count != 0) {
				setTimeout(() => {
					this.notificationStack.shift();
					this.value = true;
				}, 100);
			}
		}
	},
	methods:{
		goToRoute(){
			this.$router.push(this.current.click_action);
			this.value = false
		}
	}
};
</script>

<style scoped>
.v-snack >>> .v-snack__content{
	padding: 0;
	margin: 0;
}

.v-snack__content{
}
</style>